(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-fit-warning"] && !Shopify.designMode) return;
  try {
    (function () {
  var AUTO_HIDE_MS = 6000;

  function showToast(toast) {
    if (!toast || toast.dataset.shown === 'true') return;
    toast.dataset.shown = 'true';
    toast.hidden = false;

    requestAnimationFrame(function () {
      toast.classList.add('size-fit-warning--visible');
    });

    window.clearTimeout(toast._sizeFitWarningTimeout);
    toast._sizeFitWarningTimeout = window.setTimeout(function () {
      toast.classList.remove('size-fit-warning--visible');
    }, AUTO_HIDE_MS);
  }

  function hideToast(toast) {
    if (!toast) return;
    window.clearTimeout(toast._sizeFitWarningTimeout);
    toast.classList.remove('size-fit-warning--visible');
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target.tagName !== 'INPUT' && target.tagName !== 'SELECT') return;

    var zone = target.closest('[data-size-fit-warning-zone]');
    if (!zone) return;

    showToast(document.getElementById('SizeFitWarningToast'));
  });

  document.addEventListener('click', function (event) {
    var closeButton = event.target.closest('.size-fit-warning__close');
    if (!closeButton) return;
    hideToast(closeButton.closest('.size-fit-warning'));
  });
})();
  } catch(e) { console.error(e); }
})();

})();
